import Footer from 'apollo-react/components/Footer';

const FooterCustom = (props) => {
    return (
        <Footer
            // style={{
            //     marginLeft: window.location.href.includes("login") || window.location.pathname === "/" ? 0 :
            //     props.isSidebarCollapsed ? 64 : 320,
            //     justifyContent: 'space-between',
            //   }}
            buttonProps={[
            {
                label: 'Terms of Use',
                href: 'https://www.iqvia.com/about-us/terms-of-use',
                target: '_blank',
            },
            {
                label: 'Privacy Policy',
                href: 'https://www.iqvia.com/about-us/privacy/privacy-policy',
                target: '_blank',
            },
            {
                label: 'Contact us',
                href: 'mailto:eService@iqvia.com ',
                target: '_blank',
                onClick: () => console.log('Contact us'),
            },
            ]}
            maxWidth={1600}
        />
    );
}

export default FooterCustom;